import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import {Card, CardActions, CardContent, CardMedia, Button, Typography} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import ModeEditIcon from '@mui/icons-material/ModeEdit';

import useStyles from './styles.js'

import avatar from '../../../images/empty_team.jpg'
import { deleteTeam } from '../../../actions/teams.js'
import { isAdminUser } from '../../../actions/auth.js'

const Team = ({ team, setCurrentId, reload }) => {
    const classes = useStyles();

    const dispatch = useDispatch()

    const [image, setImage] = useState(avatar)


    useEffect(() => {
        if(team.logoUrl){
                setImage(team.logoUrl)
        }
        
    }, [team])

    
    return (
        <Card className={classes.card}>
            <CardMedia className={classes.media} image={image} title={team.name}/>

            <div className={classes.details}>

            </div>
            <CardContent>
                <Typography className={classes.title} variant="h5" gutterBottom>{team.name}</Typography>
            </CardContent>

            <CardActions className={classes.cardActions}>
            {isAdminUser() && <Button size="small" color="primary" onClick={() => {dispatch(deleteTeam(team._id)); reload()}}>
                    <DeleteIcon fontSize="small"/>
                    Supprimer
                </Button>}

                <Button size="small" color="primary" onClick={() => {setCurrentId(team._id)}}>
                    <ModeEditIcon fontSize="small" />
                    Editer
                </Button> 
            </CardActions>
        </Card>
    )
}

export default Team